import { render, staticRenderFns } from "./trafficGuidance.vue?vue&type=template&id=538ed522&scoped=true&"
import script from "./trafficGuidance.vue?vue&type=script&lang=js&"
export * from "./trafficGuidance.vue?vue&type=script&lang=js&"
import style0 from "./trafficGuidance.vue?vue&type=style&index=0&id=538ed522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ed522",
  null
  
)

export default component.exports